import React from "react";
import { CustomDialog, icon } from "../../../../../../common/components";
import { translate } from "../../../../../../common/providers";
import styles from "./RedressDialog.module.css";

const RedressDelete = ({ content, open, onClose, onSubmit }) => (
	<CustomDialog
		classes={{ paper: styles.dialogRoot }}
		iconColor="var(--red-500)"
		iconModel={icon.faExclamationTriangle}
		open={open}
		submitColor="destructive"
		submitLabel={translate("common:btn.confirm")}
		subTitle={
			<div>
				<div>{translate("smart-review.redress-dialog.item-delete-content.message")}</div>
				<div className={styles.deleteContent}>{content}</div>
			</div>
		}
		onClose={onClose}
		onSubmit={onSubmit}
	/>
);

export default RedressDelete;
